import { ColorsFasciaGroups, GroupAlign, TextSize } from '@as/cotopaxi';
export const aemColorToCotopaxiColor = {
    contrast: 'N300',
    'high-contrast': 'N700',
    accent: ColorsFasciaGroups.DIVIDER_LIST,
    neutral: 'N100',
    'neutral-accent': 'N200',
    'accent-primary': ColorsFasciaGroups.DIVIDER_LIST,
    dark: 'N700',
    'medium-lighter': 'N200',
    'medium-darker': 'N300',
    light: 'N100',
};
export const mapTextColorToDividerLineColor = {
    'accent-primary': 'dark',
    dark: 'dark',
    'medium-lighter': 'neutral',
    'medium-darker': 'neutral',
    light: 'neutral',
};
export const mapListItemTextSize = {
    small: TextSize.SMALL,
    medium: TextSize.MEDIUM,
    large: TextSize.LARGE,
};
export const mapGroupAlign = {
    left: undefined,
    center: GroupAlign.CENTER,
    right: GroupAlign.RIGHT,
};
